import React, { memo } from "react";

type Props = {
  title: string;
  value: string | number;
};
export const ResultScoreItem = memo(({ title, value }: Props) => {
  return (
    <div className="w-full flex flex-wrap items-center justify-between pl-2.5 pr-4 py-2 bg-border rounded-[10px] md:min-w-auto">
      <p className="text-grayDark font-black font-base">{title}</p>
      <strong className="text-grayDark font-black font-base">{value}</strong>
    </div>
  );
});
